import { fork, all } from 'redux-saga/effects'
import fetchArticles from "./articles"
import fetchTrending from "./trending"
import fetchProductsSaga from './products'
import searchSaga from './search'
import accountSaga from './account'
import userMetadataSaga from './userMetadata';

export default function* root() {
    yield all([
        fork(fetchArticles),
        fork(fetchTrending),
        fork(fetchProductsSaga),
        fork(searchSaga),
        fork(accountSaga),
        fork(userMetadataSaga)
    ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js